import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {
  today = Date.now();
  sort = false;

  hideText() {
    this.sort = true;
  }

  showText() {
    this.sort = false;
  }
  constructor() { }

  ngOnInit() {
  }

}
